import API_MAP from '../configs/url-api';

export function getLandingSettings() {
  return request(`${API_MAP.LANDING}/settings`, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function updateLandingSettings(data, id) {
  return request(`${API_MAP.LANDING}/${id}`, {
    method: 'PATCH',
    auth: 'Bearer',
    body: data,
  });
}

export function getLandingReviews() {
  return request(API_MAP.LANDING_REVIEWS, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function addLandingReview(data) {
  return request(API_MAP.LANDING_REVIEWS, {
    method: 'POST',
    auth: 'Bearer',
    body: data,
  });
}

export function updateLandingReviews(data, id) {
  return request(`${API_MAP.LANDING_REVIEWS}/${id}`, {
    method: 'PATCH',
    auth: 'Bearer',
    body: data,
  });
}

export function deleteLandingReviews(id) {
  return request(`${API_MAP.LANDING_REVIEWS}/${id}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}
